import { render, staticRenderFns } from "./CallOperatorTariffZones.vue?vue&type=template&id=12a40f18&"
import script from "./CallOperatorTariffZones.vue?vue&type=script&lang=ts&"
export * from "./CallOperatorTariffZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports